import {
    GETKYCCONFIGURATIONDETAILS_SUCCESS,
    GETKYCCONFIGURATIONDETAILS_FAILED,
    RESET_GETKYCCONFIGURATIONDETAILS,
    LOADING_GETKYCCONFIGURATIONDETAILS,
    NETWORK_ERROR_GETKYCCONFIGURATIONDETAILS,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetKycConfigurationDetails = () => {
    return { type: RESET_GETKYCCONFIGURATIONDETAILS };
};

const getKycConfigurationDetails =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETKYCCONFIGURATIONDETAILS });
        await partnerServices
            .post("getKycConfigurationDetails", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.status) {
                    case "success":
                        dispatch(getKycConfigurationDetailsSuccess(res.data));
                        break;
                    default:
                        dispatch(getKycConfigurationDetailsFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GETKYCCONFIGURATIONDETAILS,
                    payload: err,
                });
            });
    };
function getKycConfigurationDetailsSuccess(data) {
    return {
        type: GETKYCCONFIGURATIONDETAILS_SUCCESS,
        payload: data,
    };
}
function getKycConfigurationDetailsFailed(data) {
    return {
        type: GETKYCCONFIGURATIONDETAILS_FAILED,
        payload: data,
    };
}

export { resetGetKycConfigurationDetails, getKycConfigurationDetails };
